module.exports = __webpack_public_path__ + "img/expert-photo.de9dd405.png";